import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shell-stack" }
const _hoisted_2 = {
  key: 0,
  class: "shell-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs_item = _resolveComponent("v-breadcrumbs-item")!
  const _component_v_breadcrumbs_divider = _resolveComponent("v-breadcrumbs-divider")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!

  return (_openBlock(), _createBlock(_component_v_breadcrumbs, {
    items: [],
    divider: "›",
    density: "compact",
    class: "app-breadcrumb"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs_item, {
        to: {name: 'home'},
        title: _ctx.$tt('workspaces-all')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.HOME_ICON), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crumbs, (crumb) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: (crumb.label || '') + '\u0000' + crumb.text
        }, [
          _createVNode(_component_v_breadcrumbs_divider),
          _createVNode(_component_v_breadcrumbs_item, {
            to: crumb.to
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                (crumb.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(crumb.label), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(crumb.label ? 'shell-value' : 'shell-label shell-step')
                }, _toDisplayString(crumb.text), 3)
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}